import { Form, Formik } from 'formik';
import { useCallback, useMemo } from 'react';
import {
  Buttons,
  FieldsRow,
} from '@seller-hermes/features/login/login-modal-styles';

import { schemaConstructor, ISchema } from './schema';
import useYupSchema from '@seller-hermes/hooks/use-yup-schema.hook';
import Field from '@seller-hermes/features/ui/Field/field.formik';
import Button from '@seller-hermes/features/ui/Button';
import { useTranslation } from 'react-i18next';
import Radio from '@seller-hermes/features/ui/Radio/radio.formik';
import { ContentContainer, Description } from './dialogs.styles';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { report } from './report.query';

const sectionOptions = [
  { label: 'suggestion', value: 'suggestion' },
  { label: 'bug-report', value: 'bug-report' },
];

interface Props {
  close: () => void;
}

const SuggestDialogContent: React.FC<Props> = ({ close }) => {
  const schema = useYupSchema(schemaConstructor);
  const locatiton = useLocation();
  const { t } = useTranslation('suggest-dialog');
  const handleSubmit = useCallback(
    async (data: ISchema) => {
      const { message, type } = data;
      const path = locatiton.pathname;
      await report({ message, type, path });
      toast.info(t('thanks'));
      close();
    },
    [locatiton, t, close]
  );
  const sections = useMemo(
    () =>
      sectionOptions.map((option) => ({ ...option, label: t(option.label) })),
    [t]
  );
  return (
    <ContentContainer>
      <Description>{t('description')}</Description>
      <Formik
        initialValues={{ message: '', type: 'suggestion' } as ISchema}
        validationSchema={schema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <FieldsRow>
              <Field
                multiline
                rowsMax={4}
                name="message"
                placeholder={t('message-placeholder')}
                label={t('message')}
              />
            </FieldsRow>
            <FieldsRow>
              <Radio label={t('type')} name="type" options={sections} />
              {/* <Select options={sections} name="section" label={t("section")} /> */}
            </FieldsRow>
            <Buttons>
              <Button
                isLoading={isSubmitting}
                type="submit"
                variant="contained"
                color="primary"
              >
                {t('submit')}
              </Button>
            </Buttons>
          </Form>
        )}
      </Formik>
    </ContentContainer>
  );
};

export default SuggestDialogContent;
